import React, {useEffect, useState} from 'react';
import {Button} from "antd";
import {useSelector} from "react-redux";
import {useAppDispatch} from "../../../store";
import {renewSubscription} from "../../../store/actions";
import {confirmAlert} from "react-confirm-alert";

interface Props {
    widget: any,
    keyIndex: number
}

const PaymentRetry = ({ widget, keyIndex }: Props) => {

    const dispatch = useAppDispatch();

    const [renewalAmount, setRenewalAmount] = useState<string>('');

    const [billingCycle, setBillingCycle] = useState<'Monthly' | 'Annual'>('Monthly');

    const {
        userDetails
    } = useSelector<any, any>(({ user }) => user);
    const {
        renewalChargingDataList
    } = useSelector<any, any>(({ settings }) => settings);

    useEffect(() => {
        if (widget && Array.isArray(renewalChargingDataList)) {
            const chargingData = renewalChargingDataList.find(
                (obj: any) => obj.widgetType === widget.widgetType && obj.index.toString() === keyIndex.toString()
            );

            if (chargingData) {
                setRenewalAmount(chargingData.chargingAmount);

                const rateCardType = widget.WidgetRate[0]?.RateCard?.name;

                if (rateCardType === 'Annual charge') {
                    setBillingCycle('Annual');
                } else {
                    setBillingCycle('Monthly');
                }
            }
        }
    }, [renewalChargingDataList, widget, keyIndex]);


    const onRetry = async () => {
        confirmAlert({
            message: `Are you sure you want to renew your subscription?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
                        if(tenantGroupId && widget && widget.uuid) {
                            dispatch<any>(renewSubscription(tenantGroupId, widget.uuid));
                        }
                    }
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    return (
        <div className="panel-inner-feature-content__wrapper" style={{ width: '100%' }}>
            <span className="panel-inner-feature-content-title">
                Pending Renewal
            </span>
            <div className="panel-inner-feature-content">
                <p>
                    Renew your subscriptions to explore more features on below product.
                </p>
                {renewalAmount &&
                    <p>
                        {`You will be charged Rs. ${renewalAmount} + tax as ${billingCycle.toLowerCase()} subscription`}
                    </p>
                }
                <div className="form-group__wrapper">
                    <div className="panel-table-list-item" style={{ justifyContent: "center", borderBottom: "none" }}>
                        <Button className='btn btn-primary' onClick={onRetry}>
                            Renew Subscriptions
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { PaymentRetry };